// libs
import { styled } from '@nykaa/ui-components';

export const Container = styled.aside`
  width: 100%;
  min-width: 0;
`;

export const Title = styled.h2`
  margin: 0 0 ${({ theme }) => theme.spacing.spacing80};
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleSmall};
`;

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.spacing80};
  padding: ${({ theme }) => `${theme.spacing.spacing40} ${theme.spacing.spacing60}`};
  background-color: ${({ theme }) => theme.colors.surface20};
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.subTitleSmall};
`;

export const HeaderLabel = styled.span`
  flex: 1;
  min-width: 0;
`;

export const HeaderPriceLabel = styled.span`
  flex-shrink: 0;
  text-align: right;
`;

export const ItemList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Item = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.colors.surface30};
`;

export const ItemLink = styled.a`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.spacing80};
  padding: ${({ theme }) => `${theme.spacing.spacing60} ${theme.spacing.spacing60}`};
  text-decoration: none;
  color: inherit;

  &:hover {
    background-color: ${({ theme }) => theme.colors.surface10};
  }

  &:focus-visible {
    outline: ${({ theme }) =>
      `${theme.spacing.spacing10} ${theme.borders.border100.borderStyle} ${theme.colors.secondary}`};
    outline-offset: ${({ theme }) => `-${theme.spacing.spacing10}`};
  }
`;

export const ProductName = styled.span`
  flex: 1;
  min-width: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleXSmall};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ProductPrice = styled.span`
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleXSmall};
  text-align: right;
  white-space: nowrap;
`;
